<ng-container [ngSwitch]="selectedItem?.menuType">
  <shrd-pf-ft-contact-header *ngSwitchCase="menuTypes.CONTACT"></shrd-pf-ft-contact-header>
  <shrd-uic-ribbon *ngSwitchDefault class="w-100">
    <div class="col-24">
      <div class="content-box">
        <div class="heading-md text-bold mb-0">
          {{ selectedItem?.headerLabel || selectedItem?.title }}
        </div>
      </div>
    </div>
  </shrd-uic-ribbon>
</ng-container>
